import { is } from '@common/is/is'
import { RX } from '@common/RX/RX'

import getGPUInfo from './getGPUInfo'

// problémás GPU regexek (bővíthető)
const PROBLEM_GPU = [
  /Mali-G5\d+/i,
  /Mali-G6\d+/i,
  /Mali-G7\d+/i,
  /Xclipse \d+/i
] as const

/**
 * Zoom-ot használjunk a transform helyett?
 * @param isChrome - Az eszközünk Chrome böngészőt használ?
 */
export default function shouldApplyZoom (isChrome: boolean): boolean {
  if (!isChrome) {
    return false
  }

  const gpuString = getGPUInfo()

  if (is.null(gpuString)) {
    return false
  }

  return PROBLEM_GPU.some((regex) => RX.test(regex, gpuString))
}
